import { createSelector } from '@reduxjs/toolkit';
import { selectCeilingHeight } from 'shared/selectors/jsonQuery';

export const selectCeilingHeightValue = createSelector(selectCeilingHeight, ceilingHeight => ceilingHeight.gte || null);
